module.exports = __webpack_public_path__ + "static/media/hamamo_only_logo.5b8ad18d.png";